/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 */
export function once(fn) {
    let called = false;
    let result;
    return function (...args) {
        if (called)
            return result;
        called = true;
        result = fn.apply(this, args);
        return result;
    };
}
//# sourceMappingURL=function.js.map